// extracted by mini-css-extract-plugin
module.exports = {"tabs":"a10a3f92e9--tabs--3C08u"};